import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const ItemCourseSkltn = (props) => {

    const [arry, setArry] = useState([])

    useEffect(() => {
        let temp = []
        for (let i = 0; i < props.count; i++) {
            temp.push(i)
        }
        setArry(temp)
    }, [])

    return (
        <div className="skltn-row">
            {arry.slice(0, 9).map((info, index) =>
                <div className="MyCourses" >
                    <div className="infos">
                        <Skeleton animation="wave" variant="rect" width={100 + '%'} height={22} />
                        <Skeleton animation="wave" variant="rect" width={65 + '%'} height={22} />
                        <Skeleton animation="wave" variant="rect" width={65 + '%'} height={22} />
                        <Skeleton animation="wave" variant="rect" width={65 + '%'} height={22} />
                    </div>
                    <div className="progress">
                        <Skeleton animation="wave" variant="rect" width={100 + '%'} height={100 + '%'} />
                    </div>
                </div>
            )}
        </div>
    );
}

export default ItemCourseSkltn;